import { Breadcrumb, BreadcrumbType } from './types';

const MAX_BREADCRUMBS = 25;

export class BreadcrumbCollector {
  private buffer: Breadcrumb[] = [];

  add(type: BreadcrumbType, message: string, data?: Record<string, unknown>): void {
    const breadcrumb: Breadcrumb = {
      type,
      message,
      timestamp: new Date().toISOString(),
      ...(data !== undefined ? { data } : {}),
    };
    this.buffer.push(breadcrumb);
    if (this.buffer.length > MAX_BREADCRUMBS) {
      this.buffer.shift();
    }
  }

  getAll(): Breadcrumb[] {
    return [...this.buffer];
  }

  installClickListener(): void {
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target as HTMLElement;
        const label =
          target.getAttribute('aria-label') ||
          (target.innerText?.trim() || '').slice(0, 50) ||
          target.tagName.toLowerCase();
        this.add('click', label);
      },
      { capture: true, passive: true },
    );
  }
}
